<ng-template #addReason>
  <i class="material-icons reclass-add-icon">add_circle</i>
  <span class="p-2">Add</span>
</ng-template>
<ng-template #viewReason>
  <i class="material-icons reclass-add-icon">edit</i>
  <span class="p-2">Edit</span>
</ng-template>

<div id="reclassificationForm">
  <app-adjustement-modal-template title="{{ sectionName }} Reclass" [showHeader]="false" [spinnerVisible]="spinnerVisible$ | async">
    <div body *ngIf="results">
      <!-- div class="overlay" *ngIf="true">
        <app-spinner></app-spinner>
      </div -->
      <p-tabView id="reclassification" class="flex-fill" styleClass="balance-sheet-tabs reclassification" (onChange)="tabChanged($event)">
        <ng-container *ngFor="let y of years; index as i">
          <p-tabPanel headerStyleClass="no-corners" header="{{ y }}" [selected]="y === selectedYear">
            <div class="pb-3">
              <form autocomplete="off" [formGroup]="adjustmentForm" (submit)="onSubmit()" *ngIf="sectionName !== averageAssetsSectionName">
                <app-check-box-group
                  [horizontalAlign]="true"
                  [values]="adjustmentTypes"
                  formControlName="adjustmentTypes"
                  labelName="displayText"
                ></app-check-box-group>
              </form>
              <div *ngIf="!this.lifoReserveAdjAvailable">
                <span class="warning-msg">{{ noLifoMsg }}</span>
              </div>
              <div *ngIf="!adjCombinationValid(adjustmentForm.controls.adjustmentTypes.value)">
                <hr />
                <span class="reclass-error">{{ errorMsg_adjCombNotAllowed }}</span>
              </div>
            </div>

            <div class="d-flex">
              <div class="p-0 flex-fill min-width reclass-column">
                <div class="d-flex flex-column reclass-header">
                  <div class="flex-fill font-weight-bold pb-2">Financial</div>
                  <div>Reason</div>
                </div>
                <ng-container *ngFor="let rec of formFields">
                  <div class="d-flex flex-column">
                    <div class="flex-fill re-class-field pt-2">
                      {{ rec.placeholder }}
                    </div>
                  </div>
                </ng-container>
              </div>
              <div class="p-0 flex-fill min-width reclass-column">
                <div class="d-flex flex-column reclass-header">
                  <div class="flex-fill font-weight-bold pb-0">
                    {{ sourceName }}
                  </div>
                  <div>...</div>
                </div>
                <ng-container *ngFor="let rec of formFields">
                  <div class="d-flex flex-column">
                    <div class="flex-fill re-class-field pt-2">
                      {{ rec.value[sourceName.toLowerCase() + '_' + y] === null ? 'N/A' : (rec.value[sourceName.toLowerCase() + '_' + y] | number) }}
                    </div>
                  </div>
                </ng-container>
              </div>

              <ng-container
                *ngIf="sectionVisible('Replacement', adjustmentForm.controls.adjustmentTypes.value) && sectionName !== averageAssetsSectionName"
              >
                <div class="p-0 flex-fill min-width reclass-column">
                  <div class="d-flex flex-column reclass-header">
                    <div class="flex-fill font-weight-bold pb-0">
                      Replacement
                      <a *ngIf="!readOnly" (click)="removedMetrics('Replacement')">
                        <span><i class="material-icons delete-icon">delete</i></span>
                      </a>
                    </div>
                    <div>
                      <a (click)="openReasonModal(reasonTypes.replacement, replacementReason)">
                        <ng-template *ngIf="replacementReason && replacementReason.length > 0; then viewReason; else addReason"></ng-template>
                      </a>
                    </div>
                  </div>
                  <form autocomplete="off" [formGroup]="replacementForm">
                    <ng-container *ngFor="let ff of formFields">
                      <div class="d-flex flex-column">
                        <div class="flex-fill re-class-field">
                          <!--  appTwoDigitDecimaNumber this directive does not work on type="number", as selectionstart property of input does not work on number-->
                          <input
                            [placeholder]="ff.placeholder"
                            [formControlName]="ff.formControlName"
                            class="form-control"
                            id="replacement_{{ ff.formControlName }}"
                            name="replacement_{{ ff.formControlName }}"
                            [readOnly]="ff.readonly"
                            appTwoDigitDecimaNumber
                          />
                        </div>
                      </div>
                    </ng-container>
                  </form>
                </div>
              </ng-container>
              <ng-container
                *ngIf="sectionVisible('LIFO Adjustment', adjustmentForm.controls.adjustmentTypes.value) && sectionName !== averageAssetsSectionName"
              >
                <div class="p-0 flex-fill min-width reclass-column">
                  <div class="d-flex flex-column reclass-header">
                    <div class="flex-fill font-weight-bold pb-0">
                      LIFO Adjustment
                      <a *ngIf="!readOnly" (click)="removedMetrics('LIFO Adjustment')">
                        <span><i class="material-icons delete-icon">delete</i></span>
                      </a>
                    </div>
                    <div>
                      <a (click)="openReasonModal(reasonTypes.LIFO, lIFOReason)">
                        <ng-template *ngIf="lIFOReason && lIFOReason.length > 0; then viewReason; else addReason"></ng-template>
                      </a>
                    </div>
                  </div>
                  <form autocomplete="off" [formGroup]="lifoForm">
                    <ng-container *ngFor="let ff of formFields">
                      <div class="d-flex flex-column">
                        <div class="flex-fill re-class-field">
                          <!--  appTwoDigitDecimaNumber this directive does not work on type="number", as selectionstart property of input does not work on number-->
                          <input
                            [placeholder]="ff.placeholder"
                            [formControlName]="ff.formControlName"
                            [readOnly]="true"
                            class="form-control"
                            id="lifo_{{ ff.formControlName }}"
                            name="lifo_{{ ff.formControlName }}"
                            appTwoDigitDecimaNumber
                          />
                        </div>
                      </div>
                    </ng-container>
                  </form>
                </div>
              </ng-container>
              <ng-container
                *ngIf="sectionVisible('Reclassification', adjustmentForm.controls.adjustmentTypes.value) && sectionName !== averageAssetsSectionName"
              >
                <div class="p-0 flex-fill min-width reclass-column">
                  <div class="d-flex flex-column reclass-header">
                    <div class="flex-fill font-weight-bold pb-0">
                      Reclassification
                      <a *ngIf="!readOnly" (click)="removedMetrics('Reclassification')">
                        <span><i class="material-icons delete-icon">delete</i></span>
                      </a>
                    </div>
                    <div>
                      <a (click)="openReasonModal(reasonTypes.reclassification, reclassificationReason)">
                        <ng-template
                          *ngIf="reclassificationReason && reclassificationReason.length > 0; then viewReason; else addReason"
                        ></ng-template>
                      </a>
                    </div>
                  </div>
                  <form autocomplete="off" [formGroup]="reclassificationForm">
                    <ng-container *ngFor="let ff of formFields">
                      <div class="d-flex flex-column">
                        <div class="flex-fill re-class-field">
                          <!--  appTwoDigitDecimaNumber this directive does not work on type="number", as selectionstart property of input does not work on number-->
                          <input
                            [placeholder]="ff.placeholder"
                            [formControlName]="ff.formControlName"
                            class="form-control"
                            id="reclassification_{{ ff.formControlName }}"
                            name="reclassification_{{ ff.formControlName }}"
                            [readOnly]="ff.readonly"
                            appTwoDigitDecimaNumber
                          />
                        </div>
                      </div>
                    </ng-container>
                  </form>
                </div>
              </ng-container>

              <div class="p-0 flex-fill min-width reclass-column">
                <div class="d-flex flex-column reclass-header">
                  <div class="flex-fill font-weight-bold pb-0">Final</div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-primary btn-reclass-calc"
                      [disabled]="readOnly || !adjustmentForm.valid || !adjCombinationValid(adjustmentForm.controls.adjustmentTypes.value)"
                      (click)="calculateAdjustment()"
                    >
                      Calculate
                    </button>
                  </div>
                </div>
                <form autocomplete="off" [formGroup]="finalForm">
                  <ng-container *ngFor="let ff of formFields">
                    <div class="d-flex flex-column">
                      <div class="flex-fill re-class-field">
                        <input
                          [readOnly]="true"
                          type="number"
                          [formControlName]="ff.formControlName"
                          [placeholder]="ff.placeholder"
                          class="form-control"
                          id="result_{{ ff.formControlName }}"
                          name="result_{{ ff.formControlName }}"
                        />
                      </div>
                    </div>
                  </ng-container>
                </form>
              </div>
            </div>
          </p-tabPanel>
        </ng-container>
      </p-tabView>
    </div>
    <div footer>
      <button type="button" class="btn btn-default m-2" (click)="close()">Cancel</button>
      <button type="submit" class="btn btn-primary m-2" (click)="onSubmit()" [disabled]="submitDisabled()">Save</button>
    </div>
  </app-adjustement-modal-template>
</div>
